// frontend/src/pages/PurchaseConfig.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Page from "../ui/Page";
import { Button } from "../ui/UIComponents";

export default function PurchaseConfig() {
  const nav = useNavigate();

  function open(path) {
    nav(path);
  }

  function backToPurchase() {
    // Back to Purchase department tool list
    nav("/dept/purchase");
  }

  const tools = [
    {
      id: 1,
      vi: "Thuế nhập khẩu",
      en: "HS Code",
      descVi: "Quản lý mã HS và mức thuế",
      descEn: "Manage HS codes",
      path: "/purchase/config/hs-code",
    },
    {
      id: 2,
      vi: "ExW",
      en: "Accessory",
      descVi: "Quản lý ExW",
      descEn: "Manage ExW Price",
      path: "/purchase/config/ewp-accessory",
    },
    {
      id: 3,
      vi: "Retail",
      en: "Accessory",
      descVi: "Quản lý mã, mô tả, xuất xứ",
      descEn: "Manage code, description, origin, RSP",
      path: "/purchase/config/retail-product",
    },
    {
      id: 4,
      vi: "SRP",
      en: "Config",
      descVi: "Quản lý công thức liên quan đến tính giá bán lẻ",
      descEn: "Manage retail price related configuration",
      path: "/purchase/config/srp",
    },
    {
      id: 5,
      vi: "SRP",
      en: "Courier",
      descVi: "Quản lý phí Ship cho SRP",
      descEn: "Manage courier price for SRP",
      path: "/purchase/config/srp-courier",
    },
  ];

  return (
    <Page>
      <main className="container">
        <h1 className="menu-title">Tuiss Web Tools — Purchase</h1>
        <h2 style={{ marginTop: -8 }}>Setup / Configuration</h2>

        <div style={{ margin: "8px 0 16px" }}>
          <Button onClick={backToPurchase}>← Trở về / Back</Button>
        </div>

        <div className="menu-grid">
          {tools.map((t) => (
            <button
              key={t.id}
              className="menu-card"
              onClick={() => open(t.path)}
              title={`${t.vi} / ${t.en}`}
            >
              <span className="menu-id">{t.id}.</span>
              <span className="menu-text">
                {t.vi} / {t.en}
              </span>
              <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>
                {t.descVi} / {t.descEn}
              </div>
            </button>
          ))}
        </div>
      </main>
    </Page>
  );
}
